import appState from "src/AppState"

const state = {
    appState: appState,
}

export default state